module.exports = __webpack_public_path__ + "static/media/fileuploaded.6e68aec3.png";